export default __webpack_public_path__ + "static/media/old.e065c005.png";